module.exports = __webpack_public_path__ + "static/media/07(2).b60e8ee8.jpg";